export const collectionProducts: Record<string, Array<{
  id: string;
  name: string;
  price: number;
  image: string;
  category: string;
}>> = {
  '/collections/latest': [
    {
      id: 'latest-001',
      name: '中國純棉印花連帽衛衣套裝',
      price: 298,
      image: 'https://public.readdy.ai/ai/img_res/1bfc1bc25b1ba89974c87c66b0d0c276.jpg',
      category: 'latest'
    },
    {
      id: 'latest-002',
      name: '女童甜美蝴蝶結針織開衫外套',
      price: 268,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20girls%20sweet%20bow%20knit%20cardigan%20sweater%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20pastel%20pink%20color%2C%20elegant%20design&width=400&height=533&seq=latest002&orientation=portrait',
      category: 'latest'
    },
    {
      id: 'latest-003',
      name: '男童運動風連帽外套',
      price: 328,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20boys%20sporty%20hooded%20jacket%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20navy%20blue%20color%2C%20athletic%20design&width=400&height=533&seq=latest003&orientation=portrait',
      category: 'latest'
    },
    {
      id: 'latest-004',
      name: '女童格紋百褶裙套裝',
      price: 288,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20girls%20plaid%20pleated%20skirt%20outfit%20set%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20classic%20pattern%2C%20school%20uniform%20inspired&width=400&height=533&seq=latest004&orientation=portrait',
      category: 'latest'
    },
    {
      id: 'latest-005',
      name: '男童休閒牛仔外套',
      price: 358,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20boys%20casual%20denim%20jacket%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20light%20blue%20wash%2C%20trendy%20design&width=400&height=533&seq=latest005&orientation=portrait',
      category: 'latest'
    },
    {
      id: 'latest-006',
      name: '女童蕾絲拼接連衣裙',
      price: 318,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20girls%20lace%20detail%20dress%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20white%20and%20pink%20colors%2C%20elegant%20princess%20style&width=400&height=533&seq=latest006&orientation=portrait',
      category: 'latest'
    },
    {
      id: 'latest-007',
      name: '男童字母印花T恤套裝',
      price: 248,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20boys%20letter%20print%20t-shirt%20outfit%20set%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20casual%20streetwear%2C%20comfortable%20cotton&width=400&height=533&seq=latest007&orientation=portrait',
      category: 'latest'
    },
    {
      id: 'latest-008',
      name: '女童毛絨背心裙',
      price: 298,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20girls%20fluffy%20vest%20dress%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20warm%20beige%20color%2C%20cozy%20winter%20wear&width=400&height=533&seq=latest008&orientation=portrait',
      category: 'latest'
    }
  ],
  '/collections/girls': [
    {
      id: 'girls-001',
      name: '女童碎花雪紡連衣裙',
      price: 60,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20girls%20floral%20chiffon%20dress%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20pastel%20flower%20pattern%2C%20flowing%20fabric%2C%20spring%20summer%20wear&width=400&height=533&seq=girls001&orientation=portrait',
      category: 'girls'
    },
    {
      id: 'girls-002',
      name: '女童針織毛衣套裝',
      price: 60,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20girls%20knit%20sweater%20outfit%20set%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20cream%20color%2C%20cozy%20warm%20design&width=400&height=533&seq=girls002&orientation=portrait',
      category: 'girls'
    },
    {
      id: 'girls-003',
      name: '女童公主風蓬蓬裙',
      price: 60,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20girls%20princess%20tutu%20dress%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20pink%20tulle%20layers%2C%20elegant%20party%20dress&width=400&height=533&seq=girls003&orientation=portrait',
      category: 'girls'
    },
    {
      id: 'girls-004',
      name: '女童牛仔背帶裙',
      price: 60,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20girls%20denim%20overall%20dress%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20light%20blue%20denim%2C%20casual%20cute%20design&width=400&height=533&seq=girls004&orientation=portrait',
      category: 'girls'
    },
    {
      id: 'girls-005',
      name: '女童格子襯衫套裝',
      price: 50,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20girls%20plaid%20shirt%20outfit%20set%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20checkered%20pattern%2C%20preppy%20style&width=400&height=533&seq=girls005&orientation=portrait',
      category: 'girls'
    },
    {
      id: 'girls-006',
      name: '女童蕾絲花邊上衣',
      price: 50,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20girls%20lace%20trim%20blouse%20top%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20white%20with%20delicate%20lace%20details&width=400&height=533&seq=girls006&orientation=portrait',
      category: 'girls'
    },
    {
      id: 'girls-007',
      name: '女童羽絨棉背心',
      price: 60,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20girls%20padded%20vest%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20warm%20winter%20vest%2C%20quilted%20design&width=400&height=533&seq=girls007&orientation=portrait',
      category: 'girls'
    },
    {
      id: 'girls-008',
      name: '女童運動休閒套裝',
      price: 60,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20girls%20sporty%20casual%20outfit%20set%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20athletic%20wear%2C%20comfortable%20design&width=400&height=533&seq=girls008&orientation=portrait',
      category: 'girls'
    },
    {
      id: 'girls-009',
      name: '女童毛呢大衣外套',
      price: 60,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20girls%20wool%20blend%20coat%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20elegant%20winter%20coat%2C%20classic%20design&width=400&height=533&seq=girls009&orientation=portrait',
      category: 'girls'
    },
    {
      id: 'girls-010',
      name: '女童印花T恤短褲套裝',
      price: 60,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20girls%20printed%20t-shirt%20and%20shorts%20set%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20summer%20casual%20wear%2C%20cute%20graphics&width=400&height=533&seq=girls010&orientation=portrait',
      category: 'girls'
    }
  ],
  '/collections/girls-sets': [
    {
      id: 'girls-sets-001',
      name: '女童衛衣長褲兩件套',
      price: 60,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20girls%20sweatshirt%20and%20pants%20two%20piece%20set%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20matching%20outfit%2C%20comfortable%20casual&width=400&height=533&seq=girlssets001&orientation=portrait',
      category: 'girls-sets'
    },
    {
      id: 'girls-sets-002',
      name: '女童針織背心裙套裝',
      price: 60,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20girls%20knit%20vest%20dress%20outfit%20set%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20layered%20look%2C%20preppy%20style&width=400&height=533&seq=girlssets002&orientation=portrait',
      category: 'girls-sets'
    },
    {
      id: 'girls-sets-003',
      name: '女童襯衫短裙兩件套',
      price: 60,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20girls%20shirt%20and%20skirt%20two%20piece%20set%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20coordinated%20outfit%2C%20school%20style&width=400&height=533&seq=girlssets003&orientation=portrait',
      category: 'girls-sets'
    },
    {
      id: 'girls-sets-004',
      name: '女童運動服三件套',
      price: 60,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20girls%20athletic%20wear%20three%20piece%20set%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20sporty%20outfit%2C%20jacket%20hoodie%20pants&width=400&height=533&seq=girlssets004&orientation=portrait',
      category: 'girls-sets'
    },
    {
      id: 'girls-sets-005',
      name: '女童格紋西裝套裝',
      price: 60,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20girls%20plaid%20suit%20set%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20formal%20outfit%2C%20blazer%20and%20skirt&width=400&height=533&seq=girlssets005&orientation=portrait',
      category: 'girls-sets'
    },
    {
      id: 'girls-sets-006',
      name: '女童碎花上衣短褲套裝',
      price: 60,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20girls%20floral%20top%20and%20shorts%20set%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20summer%20outfit%2C%20cute%20flower%20print&width=400&height=533&seq=girlssets006&orientation=portrait',
      category: 'girls-sets'
    },
    {
      id: 'girls-sets-007',
      name: '女童毛衣背帶裙套裝',
      price: 60,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20girls%20sweater%20and%20overall%20dress%20set%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20layered%20outfit%2C%20autumn%20winter&width=400&height=533&seq=girlssets007&orientation=portrait',
      category: 'girls-sets'
    },
    {
      id: 'girls-sets-008',
      name: '女童蕾絲上衣裙褲套裝',
      price: 60,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20girls%20lace%20top%20and%20culottes%20set%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20elegant%20outfit%2C%20delicate%20details&width=400&height=533&seq=girlssets008&orientation=portrait',
      category: 'girls-sets'
    }
  ],
  '/collections/boys': [
    {
      id: 'boys-001',
      name: '男童連帽衛衣套裝',
      price: 60,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20boys%20hooded%20sweatshirt%20outfit%20set%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20casual%20sporty%20wear%2C%20comfortable%20design&width=400&height=533&seq=boys001&orientation=portrait',
      category: 'boys'
    },
    {
      id: 'boys-002',
      name: '男童牛仔外套',
      price: 60,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20boys%20denim%20jacket%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20classic%20blue%20denim%2C%20trendy%20casual&width=400&height=533&seq=boys002&orientation=portrait',
      category: 'boys'
    },
    {
      id: 'boys-003',
      name: '男童運動風衣外套',
      price: 60,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20boys%20sporty%20windbreaker%20jacket%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20athletic%20outerwear%2C%20functional%20design&width=400&height=533&seq=boys003&orientation=portrait',
      category: 'boys'
    },
    {
      id: 'boys-004',
      name: '男童格子襯衫',
      price: 50,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20boys%20plaid%20shirt%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20checkered%20pattern%2C%20casual%20preppy&width=400&height=533&seq=boys004&orientation=portrait',
      category: 'boys'
    },
    {
      id: 'boys-005',
      name: '男童字母印花T恤',
      price: 50,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20boys%20letter%20print%20t-shirt%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20graphic%20tee%2C%20streetwear%20style&width=400&height=533&seq=boys005&orientation=portrait',
      category: 'boys'
    },
    {
      id: 'boys-006',
      name: '男童休閒長褲',
      price: 50,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20boys%20casual%20pants%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20comfortable%20trousers%2C%20everyday%20wear&width=400&height=533&seq=boys006&orientation=portrait',
      category: 'boys'
    },
    {
      id: 'boys-007',
      name: '男童羽絨背心',
      price: 60,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20boys%20padded%20vest%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20warm%20winter%20vest%2C%20puffer%20design&width=400&height=533&seq=boys007&orientation=portrait',
      category: 'boys'
    },
    {
      id: 'boys-008',
      name: '男童針織毛衣',
      price: 60,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20boys%20knit%20sweater%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20cozy%20pullover%2C%20autumn%20winter&width=400&height=533&seq=boys008&orientation=portrait',
      category: 'boys'
    },
    {
      id: 'boys-009',
      name: '男童棒球外套',
      price: 60,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20boys%20baseball%20jacket%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20varsity%20jacket%2C%20sporty%20casual&width=400&height=533&seq=boys009&orientation=portrait',
      category: 'boys'
    },
    {
      id: 'boys-010',
      name: '男童工裝褲',
      price: 60,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20boys%20cargo%20pants%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20utility%20trousers%2C%20functional%20pockets&width=400&height=533&seq=boys010&orientation=portrait',
      category: 'boys'
    }
  ],
  '/collections/baby': [
    {
      id: 'baby-001',
      name: 'BABY純棉連身衣',
      price: 60,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20baby%20cotton%20romper%20bodysuit%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20pastel%20colors%2C%20soft%20fabric%2C%20newborn%20wear&width=400&height=533&seq=baby001&orientation=portrait',
      category: 'baby'
    },
    {
      id: 'baby-002',
      name: 'BABY針織套裝',
      price: 60,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20baby%20knit%20outfit%20set%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20cozy%20sweater%20and%20pants%2C%20gentle%20colors&width=400&height=533&seq=baby002&orientation=portrait',
      category: 'baby'
    },
    {
      id: 'baby-003',
      name: 'BABY連帽外套',
      price: 60,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20baby%20hooded%20jacket%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20cute%20ears%20design%2C%20warm%20outerwear&width=400&height=533&seq=baby003&orientation=portrait',
      category: 'baby'
    },
    {
      id: 'baby-004',
      name: 'BABY印花爬服',
      price: 60,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20baby%20printed%20crawler%20suit%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20cute%20animal%20prints%2C%20comfortable%20onesie&width=400&height=533&seq=baby004&orientation=portrait',
      category: 'baby'
    },
    {
      id: 'baby-005',
      name: 'BABY毛絨背心',
      price: 60,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20baby%20fluffy%20vest%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20warm%20fuzzy%20fabric%2C%20adorable%20design&width=400&height=533&seq=baby005&orientation=portrait',
      category: 'baby'
    },
    {
      id: 'baby-006',
      name: 'BABY蕾絲連衣裙',
      price: 60,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20baby%20lace%20dress%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20delicate%20lace%20details%2C%20princess%20style&width=400&height=533&seq=baby006&orientation=portrait',
      category: 'baby'
    },
    {
      id: 'baby-007',
      name: 'BABY條紋T恤套裝',
      price: 60,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20baby%20striped%20t-shirt%20set%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20classic%20stripes%2C%20casual%20outfit&width=400&height=533&seq=baby007&orientation=portrait',
      category: 'baby'
    },
    {
      id: 'baby-008',
      name: 'BABY睡衣套裝',
      price: 60,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20baby%20pajama%20set%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20comfortable%20sleepwear%2C%20gentle%20fabric&width=400&height=533&seq=baby008&orientation=portrait',
      category: 'baby'
    }
  ],
  '/collections/big-kids': [
    {
      id: 'big-kids-001',
      name: '大童運動衛衣套裝',
      price: 60,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20big%20kids%20sporty%20sweatshirt%20outfit%20set%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20athletic%20casual%20wear%2C%20teen%20fashion&width=400&height=533&seq=bigkids001&orientation=portrait',
      category: 'big-kids'
    },
    {
      id: 'big-kids-002',
      name: '大童牛仔夾克',
      price: 60,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20big%20kids%20denim%20jacket%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20trendy%20jean%20jacket%2C%20youth%20style&width=400&height=533&seq=bigkids002&orientation=portrait',
      category: 'big-kids'
    },
    {
      id: 'big-kids-003',
      name: '大童格紋襯衫',
      price: 60,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20big%20kids%20plaid%20shirt%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20checkered%20pattern%2C%20preppy%20teen%20wear&width=400&height=533&seq=bigkids003&orientation=portrait',
      category: 'big-kids'
    },
    {
      id: 'big-kids-004',
      name: '大童連帽外套',
      price: 60,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20big%20kids%20hooded%20jacket%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20sporty%20outerwear%2C%20youth%20fashion&width=400&height=533&seq=bigkids004&orientation=portrait',
      category: 'big-kids'
    },
    {
      id: 'big-kids-005',
      name: '大童休閒長褲',
      price: 60,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20big%20kids%20casual%20pants%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20comfortable%20trousers%2C%20teen%20everyday%20wear&width=400&height=533&seq=bigkids005&orientation=portrait',
      category: 'big-kids'
    },
    {
      id: 'big-kids-006',
      name: '大童針織毛衣',
      price: 60,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20big%20kids%20knit%20sweater%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20cozy%20pullover%2C%20youth%20autumn%20winter&width=400&height=533&seq=bigkids006&orientation=portrait',
      category: 'big-kids'
    }
  ],
  '/collections/homewear': [
    {
      id: 'homewear-001',
      name: '兒童珊瑚絨睡衣套裝',
      price: 70,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20children%20coral%20fleece%20pajama%20set%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20cozy%20sleepwear%2C%20warm%20fuzzy%20fabric&width=400&height=533&seq=homewear001&orientation=portrait',
      category: 'homewear'
    },
    {
      id: 'homewear-002',
      name: '兒童純棉家居服',
      price: 70,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20children%20cotton%20loungewear%20set%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20comfortable%20home%20clothes%2C%20breathable%20fabric&width=400&height=533&seq=homewear002&orientation=portrait',
      category: 'homewear'
    },
    {
      id: 'homewear-003',
      name: '兒童法蘭絨睡袍',
      price: 70,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20children%20flannel%20bathrobe%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20cozy%20robe%2C%20warm%20nightwear&width=400&height=533&seq=homewear003&orientation=portrait',
      category: 'homewear'
    },
    {
      id: 'homewear-004',
      name: '兒童卡通睡衣',
      price: 70,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20children%20cartoon%20pajamas%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20cute%20character%20prints%2C%20fun%20sleepwear&width=400&height=533&seq=homewear004&orientation=portrait',
      category: 'homewear'
    },
    {
      id: 'homewear-005',
      name: '兒童針織家居套裝',
      price: 70,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20children%20knit%20loungewear%20set%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20cozy%20home%20outfit%2C%20comfortable%20design&width=400&height=533&seq=homewear005&orientation=portrait',
      category: 'homewear'
    },
    {
      id: 'homewear-006',
      name: '兒童連體睡衣',
      price: 70,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20children%20onesie%20pajamas%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20cute%20animal%20design%2C%20cozy%20sleepwear&width=400&height=533&seq=homewear006&orientation=portrait',
      category: 'homewear'
    }
  ],
  '/collections/kids-items': [
    {
      id: 'items-001',
      name: '兒童書包',
      price: 70,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20children%20school%20backpack%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20cute%20design%2C%20functional%20bag&width=400&height=533&seq=items001&orientation=portrait',
      category: 'items'
    },
    {
      id: 'items-002',
      name: '兒童帽子',
      price: 70,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20children%20hat%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20cute%20cap%2C%20sun%20protection&width=400&height=533&seq=items002&orientation=portrait',
      category: 'items'
    },
    {
      id: 'items-003',
      name: '兒童圍巾',
      price: 70,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20children%20scarf%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20warm%20winter%20accessory%2C%20soft%20fabric&width=400&height=533&seq=items003&orientation=portrait',
      category: 'items'
    },
    {
      id: 'items-004',
      name: '兒童手套',
      price: 70,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20children%20gloves%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20warm%20winter%20gloves%2C%20cute%20design&width=400&height=533&seq=items004&orientation=portrait',
      category: 'items'
    },
    {
      id: 'items-005',
      name: '兒童襪子套裝',
      price: 70,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20children%20socks%20set%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20cute%20patterns%2C%20comfortable%20socks&width=400&height=533&seq=items005&orientation=portrait',
      category: 'items'
    },
    {
      id: 'items-006',
      name: '兒童髮飾套裝',
      price: 70,
      image: 'https://readdy.ai/api/search-image?query=Korean%20style%20children%20hair%20accessories%20set%20on%20clean%20white%20studio%20background%2C%20soft%20natural%20lighting%2C%20product%20photography%20style%2C%20cute%20clips%20and%20bands%2C%20colorful%20design&width=400&height=533&seq=items006&orientation=portrait',
      category: 'items'
    }
  ]
};

// 為其他分類路由添加相同的產品數據
collectionProducts['/collections/girls-autumn-winter'] = collectionProducts['/collections/girls'].slice(0, 8);
collectionProducts['/collections/girls-spring-summer'] = collectionProducts['/collections/girls'].slice(4, 10);
collectionProducts['/collections/girls-tops-bottoms'] = collectionProducts['/collections/girls'].slice(2, 10);
collectionProducts['/collections/girls-dresses'] = collectionProducts['/collections/girls'].slice(0, 6);
collectionProducts['/collections/girls-outerwear'] = collectionProducts['/collections/girls'].slice(6, 10);
collectionProducts['/collections/girls-suits'] = collectionProducts['/collections/girls-sets'].slice(4, 8);
collectionProducts['/collections/girls-leggings'] = collectionProducts['/collections/girls'].slice(3, 9);

collectionProducts['/collections/boys-all'] = collectionProducts['/collections/boys'];
collectionProducts['/collections/boys-autumn-winter'] = collectionProducts['/collections/boys'].slice(0, 8);
collectionProducts['/collections/boys-spring-summer'] = collectionProducts['/collections/boys'].slice(4, 10);
collectionProducts['/collections/boys-tops-bottoms'] = collectionProducts['/collections/boys'].slice(2, 10);
collectionProducts['/collections/boys-outerwear'] = collectionProducts['/collections/boys'].slice(1, 7);
collectionProducts['/collections/boys-suits'] = collectionProducts['/collections/boys'].slice(0, 4);
collectionProducts['/collections/boys-accessories'] = collectionProducts['/collections/kids-items'];

collectionProducts['/collections/big-girls'] = collectionProducts['/collections/big-kids'].slice(0, 6);
collectionProducts['/collections/big-boys'] = collectionProducts['/collections/big-kids'];

collectionProducts['/collections/baby-all'] = collectionProducts['/collections/baby'];
collectionProducts['/collections/baby-boy'] = collectionProducts['/collections/baby'].slice(0, 4);
collectionProducts['/collections/baby-girl'] = collectionProducts['/collections/baby'].slice(4, 8);
